import { IScoreCard, RmcrType } from '@nkr/models/center-performance';
import { Glyphicon, Label, OverlayTrigger, Panel } from 'react-bootstrap';
import { TableWrapper } from './styles';
import PopoverTemplate from '@nkr/components/popover-template';

interface IProps {
    data: IScoreCard[],
    centerId: number,
    loading: boolean,
    onScrollToComplianceItems: (element: string) => void
}

const ScoreCard = (props: IProps) => {
    let majorRowNumber = 1;
    let minorRowNumber = 1;

    const scrollToBottom = () => {
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }

    const addAnchor = (link, description) => {
        if (link)
            return (<a href={link} target='_blank' rel='noopener noreferrer'>{description}</a>);
        else
            return (<a onClick={scrollToBottom}>{description}</a>);
    }

    const totalExpectedFee = props.data.reduce((sum, row) => {
        if (!row.isCompliant) {
            // Waived rows count as 0
            const fee = row.isWaived ? 0 : row.expectedFee;
            return sum + (fee || 0);
        }
        return sum;
    }, 0);

    if (props.data.length == 0) {
        return (
            <Panel id='data-compliance'>
                <Panel.Heading>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Panel.Title>Routine Member Center Requirements</Panel.Title>
                        <div>Hover over each item to see details...</div>
                    </div>
                </Panel.Heading>
                <Panel.Body><Label style={{ fontSize: '100%' }}>Loading data, one moment please...</Label></Panel.Body>
            </Panel>
        );
    }

    return (
        <Panel>
            <Panel.Heading>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Panel.Title>Routine Member Center Requirements</Panel.Title>
                    <div>Hover over each item to see details...</div>
                </div>
            </Panel.Heading>

            <TableWrapper condensed bordered>
                <thead>
                    <tr>
                        <th colSpan={2} scope='col' style={{ textAlign: 'left' }}>Major</th>
                        <th style={{ width: '12%', textAlign: 'center' }}>Required</th>
                        <th style={{ width: '12%' }}>Current</th>
                        <th style={{ width: '12%' }}>Status</th>
                        <th style={{ width: '12%' }}>Billable</th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.filter(x => x.isMajor == true).map(row => {
                        return (
                            <tr key={row.type}>
                                <td>{majorRowNumber++}</td>
                                <td>
                                    <OverlayTrigger trigger={['hover', 'hover']} overlay={
                                        <PopoverTemplate dismiss={false} className='nkr-tooltip'>
                                            {row.helpText}
                                        </PopoverTemplate>
                                    }>
                                        <a href={row.link} target='_blank' rel='noopener noreferrer'>
                                            {row.description}
                                        </a>
                                    </OverlayTrigger>
                                </td>
                                <td>{row.required}</td>
                                <td>{row.value}</td>
                                <td>
                                    {row.isWaived ? (
                                        <Label bsStyle="warning">
                                            <Glyphicon glyph="minus" /> Waived
                                        </Label>
                                    ) : row.isCompliant ? (
                                        <Label bsStyle="success">
                                            <Glyphicon glyph="ok" />
                                        </Label>
                                    ) : (
                                        <Label bsStyle="danger">
                                            <Glyphicon glyph="remove" /> Not Compliant
                                        </Label>
                                    )}
                                </td>

                                <td style={{ fontWeight: 'bold', color: !row.isCompliant ? '#d9534f' : undefined }}>
                                    {!row.isCompliant ? '$' + (row.isWaived ? 0 : row.expectedFee.toLocaleString()) : ''}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>

                <thead>
                    <tr>
                        <th colSpan={2} style={{ textAlign: 'left' }}>Minor</th>
                        <th style={{ width: '12%', textAlign: 'center' }}></th>
                        <th style={{ width: '12%' }}></th>
                        <th style={{ width: '12%' }}></th>
                        <th style={{ width: '12%' }}></th>
                    </tr>
                </thead>
                <tbody>
                    {props.data.filter(x => x.isMajor != true).map(row => {
                        return (
                            <tr key={row.type}>
                                <td>{minorRowNumber++}</td>
                                <td>
                                    <OverlayTrigger trigger={['hover', 'hover']} overlay={
                                        <PopoverTemplate dismiss={false} className='nkr-tooltip'>
                                            {row.helpText}
                                        </PopoverTemplate>
                                    }>
                                        {addAnchor(row.type === RmcrType.DataCompliance ? null : row.link, row.description)}
                                    </OverlayTrigger>
                                </td>
                                <td>{row.required}</td>
                                <td>{row.value}</td>
                                <td>
                                    {row.isWaived ? (
                                        <Label bsStyle="warning">
                                            <Glyphicon glyph="minus" /> Waived
                                        </Label>
                                    ) : row.isCompliant ? (
                                        <Label bsStyle="success">
                                            <Glyphicon glyph="ok" />
                                        </Label>
                                    ) : (
                                        <Label bsStyle="danger">
                                            <Glyphicon glyph="remove" /> Not Compliant
                                        </Label>
                                    )}
                                </td>

                                <td style={{ fontWeight: 'bold', color: !row.isCompliant ? '#d9534f' : undefined }}>
                                    {!row.isCompliant ? '$' + (row.isWaived ? 0 : row.expectedFee.toLocaleString()) : ''}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <th colSpan={2} style={{ textAlign: 'left' }}></th>
                        <th style={{ textAlign: 'center' }}></th>
                        <th></th>
                        <th style={{ textAlign: 'center' }}>Total Billable ====&gt;</th>
                        <th style={{ textAlign: 'center', fontWeight: 'bold', color: '#d9534f' }}>${totalExpectedFee > 0 ? totalExpectedFee.toLocaleString() : 0}</th>
                    </tr>
                </tfoot>
            </TableWrapper>
        </Panel>
    );
}

export default ScoreCard;
